import React from 'react';
import styled from "styled-components";
import ConvertPixelToRem from "@helpers/convert.rem";
import Avatar from "@atoms/avatar";
import ButtonBase from "@atoms/button.base";
import Icon from "@atoms/icon";
import Stars from "@atoms/stars";
import {isEmpty} from "@helpers/helpers";
import {checkPropertyIsAssignedAndOwner, getContactItems} from "../../helpers/property_helpers";
import PhoneIcon from '@icons/phone.svg';
import VerifiedBadgeIcon from '@icons/verified-badge.svg';

const ShowContactContent = ({contactInfo, property, fixButtonRef, setPerContact}) => {
    const {avatarPath, profileUrl, avatarType, realtorName, agencyName} = getContactItems(property);
    const assignedAndIsOwner = checkPropertyIsAssignedAndOwner(property);

    return (
        <React.Fragment>
            {
                (!isEmpty(profileUrl)) ?
                    <a href={profileUrl}>
                        <Avatar size="88" src={avatarPath} type={avatarType}/>
                    </a>
                    :
                    <Avatar size="88" src={avatarPath} type={avatarType}/>
            }

            <Info className="mt-16">
                {
                    (!isEmpty(realtorName)) ?
                        (
                            <React.Fragment>
                                {
                                    (!isEmpty(profileUrl)) ?
                                        <a href={profileUrl} className="d-block h4" title={realtorName}>{realtorName}</a>
                                        :
                                        <h4 className="d-block h4" title={realtorName}>{realtorName}</h4>
                                }

                                <div className="d-flex align-items-center justify-content-center">
                                    <span className="d-block" title={agencyName}>
                                        {agencyName}
                                    </span>

                                    {
                                        (!isEmpty(contactInfo) && contactInfo.agency_authenticated) ?
                                            <Icon width={16} height={16} className="mr-8"><VerifiedBadgeIcon/></Icon>
                                            : ''
                                    }
                                </div>
                            </React.Fragment>
                        )

                        :

                        <React.Fragment>
                            {
                                (!isEmpty(profileUrl)) ?
                                    <a href={profileUrl} className="d-flex align-items-center justify-content-center" title={agencyName}>
                                        <span className="d-block h4">
                                            {agencyName}
                                        </span>

                                        {
                                            (!isEmpty(contactInfo) && contactInfo.agency_authenticated) ?
                                                <Icon width={16} height={16} className="mr-4"><VerifiedBadgeIcon/></Icon>
                                                : ''
                                        }
                                    </a>
                                    :
                                    <div className="d-flex align-items-center justify-content-center">
                                        <h4 className="d-block" title={agencyName}>
                                            {agencyName}
                                        </h4>

                                        {
                                            (!isEmpty(contactInfo) && contactInfo.agency_authenticated) ?
                                                <Icon width={16} height={16} className="mr-8"><VerifiedBadgeIcon/></Icon>
                                                : ''
                                        }
                                    </div>
                            }
                        </React.Fragment>
                }

                {
                    (contactInfo && isEmpty(contactInfo.agency_id) && !isEmpty(contactInfo.realtor_id) && contactInfo.stars) ?
                        <div className="d-flex align-items-center justify-content-center mt-8">
                            <Stars rate={contactInfo.stars}/>
                            {
                                (contactInfo.stars_count > 0) ?
                                    <Rate className="mr-8">{contactInfo.stars_count} نفر</Rate>
                                    : ''
                            }

                        </div>
                        :
                        ''
                }
            </Info>

            <ContactButton className="mt-32" onClick={() => setPerContact({show: true, property_id: property.id, isAssignedProperty: assignedAndIsOwner, city_id: property.city_id})} block color="secondary">
                <Icon width="16" height="16" className="ml-8">
                    <PhoneIcon/>
                </Icon>
                اطلاعات تماس
            </ContactButton>


            <FixBottomButton ref={fixButtonRef} className="d-block d-md-none bg-white px-24 py-16">
                <ContactButton onClick={() => setPerContact({show: true, property_id: property.id, city_id: property.city_id})} block color="secondary">
                    <Icon width="16" height="16" className="ml-8">
                        <PhoneIcon/>
                    </Icon>
                    اطلاعات تماس
                </ContactButton>
            </FixBottomButton>
        </React.Fragment>
    );
};

export default React.memo(ShowContactContent);


// styles

const Info = styled.div`
    width: 100%;
    
    * {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
`;

const Rate = styled.span`
    font-size: ${ConvertPixelToRem(12)};
    font-weight: normal;
    line-height: 1.58;
    color: ${props => props.theme.black};
`;

export const ContactButton = styled(ButtonBase)`
    margin-top: auto;
`;

const FixBottomButton = styled.div`
    position: fixed;
    top: unset;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1022;
`;